<div class="box bg-gradient">
  <div
    nz-row
    class="box card-login-wrapper"
  >
    <app-card-standalone
      [title]="'PAGE.AUTH.FORGOT_PASSWORD.TITLE' | translate"
    >
      <ng-container>
        <nz-alert
          class="link-expired"
          *ngIf="isLinkExpired"
          nzType="error"
          nzDescription="{{ 'PAGE.AUTH.FORGOT_PASSWORD.EXPIRED' | translate }}"
        >
        </nz-alert>

        <app-forgot-password-form></app-forgot-password-form>

        <a routerLink="/login">
          {{ "PAGE.AUTH.FORGOT_PASSWORD.LOGIN" | translate }}
        </a>
      </ng-container>
    </app-card-standalone>

    <div class="select-lang-wrapper">
      <app-select-language></app-select-language>
    </div>
  </div>
</div>
